module.exports = __webpack_public_path__ + "static/media/cloud-computing.001f16d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-computing.png
// module id = 640
// module chunks = 0